import { render, staticRenderFns } from "./Empresas.vue?vue&type=template&id=73c2e7d6&scoped=true"
import script from "./Empresas.vue?vue&type=script&lang=js"
export * from "./Empresas.vue?vue&type=script&lang=js"
import style0 from "./Empresas.vue?vue&type=style&index=0&id=73c2e7d6&prod&lang=css"
import style1 from "./Empresas.vue?vue&type=style&index=1&id=73c2e7d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c2e7d6",
  null
  
)

export default component.exports